import { useState } from 'react';
import { ModelsTabName } from '../Types/Enums';
import { RootState, useAppSelector } from '../store';
import { UserSettings } from '../Types';

const useModels = () => {
    const userSettings = useAppSelector((state: RootState) => state.userSettings as UserSettings);
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const [currentTab, setCurrentTab] = useState<ModelsTabName>(ModelsTabName.chatModels);

    return {
        userSettings,
        i18n,
        currentTab,
        setCurrentTab,
    };
};

export default useModels;
